import { GetBuyBoxDataQuery, GetZipsQuery, ZipsToCSVQueryParams } from "@shared/interfaces";
import { BuyBoxPresetDto } from "@shared/interfaces/PresetBuilder.interface";

import config from "../../config";

export default {
  AUTH: {
    LOGIN: `${config.baseApiUrl}auth/login`,
    LOGOUT: `${config.baseApiUrl}auth/logout`,
    CHECK_USER: `${config.baseApiUrl}auth/user`,
    REGISTER: `${config.baseApiUrl}auth/register`,
    FORGOT_PASSWORD: `${config.baseApiUrl}auth/password/recovery`,
    SET_PASSWORD: `${config.baseApiUrl}auth/password`,
    RESET_PASSWORD: `${config.baseApiUrl}auth/password`,
    REGISTRATION: `${config.baseApiUrl}auth/registration`,
    ACTIVATE: `${config.baseApiUrl}auth/activate`,
    IMPERSONATE: `${config.baseApiUrl}auth/impersonation`,
  },
  USER: {
    GET_USER_DETAILS: `${config.baseApiUrl}users/details`,
    GET_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    GET_USER_LIST: `${config.baseApiUrl}users`,
    CREATE_USER: `${config.baseApiUrl}users`,
    UPDATE_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    DELETE_USER: (id: string) => `${config.baseApiUrl}users/${id}`,
    ACTIVATE_USER: (id: string) => `${config.baseApiUrl}users/${id}/activate`,
    CHANGE_USER_STATUS: (id: string) => `${config.baseApiUrl}users/${id}/status`,
  },
  FILE: {
    GET_TEMP_AWS_CREDS: `${config.baseApiUrl}files/aws/credentials`,
    CREATE: `${config.baseApiUrl}files`,
    UPDATE_FILE_MAPPING: (id: string) => `${config.baseApiUrl}files/${id}/mapping`,
    GET_FILE_SIGNED_URL: (id: number) => `${config.baseApiUrl}files/${id}/signed-url`,
    MAP_FILE_TO_ACCOUNT: `${config.baseApiUrl}files/account-file-mapping`,
  },
  SKIP_TRACING: {
    GET_SKIP_TRACING_LIST: `${config.baseApiUrl}skip-tracings`,
    GET_SKIP_TRACING: (id: string) => `${config.baseApiUrl}skip-tracings/${id}`,
    CREATE_SKIP_TRACING: `${config.baseApiUrl}skip-tracings`,
    UPDATE_SKIP_TRACING: (id: string) => `${config.baseApiUrl}skip-tracings/${id}`,
    DELETE_SKIP_TRACING: (id: string) => `${config.baseApiUrl}skip-tracings/${id}`,
    TEST_SKIP_TRACING: (id: string) => `${config.baseApiUrl}skip-tracings/${id}/test`,
    PROCESS_SKIP_TRACING: (id: number) => `${config.baseApiUrl}skip-tracings/${id}/processing`,
    PAY_FOR_SKIP_TRACING: (id: number) => `${config.baseApiUrl}skip-tracings/${id}/payment`,
    GET_PRICE_RANGE: (id: number) => `${config.baseApiUrl}skip-tracings/${id}/price-range`,
    CHECK_STRIPE_COUPON: (id: number, couponId: string) => `${config.baseApiUrl}skip-tracings/${id}/coupon/${couponId}`,
  },
  INVESTOR_FILE: {
    GET_INVESTOR_FILE: (id: string) => `${config.baseApiUrl}investor-files/${id}`,
    GET_INVESTOR_FILE_LIST: `${config.baseApiUrl}investor-files`,
    SEND_INVESTOR_FILE: (id: string) => `${config.baseApiUrl}investor-files/${id}/email`,
    UNSEND_INVESTOR_FILE: (id: string) => `${config.baseApiUrl}investor-files/${id}/email`,
    DELETE_INVESTOR_FILE: (id: number) => `${config.baseApiUrl}investor-files/${id}`,
    CREATE_INVESTOR_FILE: `${config.baseApiUrl}investor-files/file`,
    SEND_INVESTOR_FILE_EMAIL: `${config.baseApiUrl}investor-files/email`,
    SEND_INVESTOR_FILES_EMAIL: `${config.baseApiUrl}investor-files/multiple/email`,
  },
  INVESTOR_SETTINGS: {
    GET_PRESET_LIST: (id: string) => `${config.baseApiUrl}investor-settings/${id}/filters`,
    GET_ES_PRESET_LIST: (id: string, full?: boolean) =>
      `${config.baseApiUrl}investor-settings/${id}/es-filters${full ? "?full=true" : ""}`,
    GET_PRESET: (id: string, filterId: string) => `${config.baseApiUrl}investor-settings/${id}/filters/${filterId}`,
    GET_ES_PRESET: (id: string, filterId: string) =>
      `${config.baseApiUrl}investor-settings/${id}/es-filters/${filterId}`,
    CREATE_PRESET: (id: string) => `${config.baseApiUrl}investor-settings/${id}/filters`,
    CREATE_ES_PRESET: (id: string) => `${config.baseApiUrl}investor-settings/${id}/es-filters`,

    UPDATE_PRESET: (id: string, filterId: string) => `${config.baseApiUrl}investor-settings/${id}/filters/${filterId}`,
    UPDATE_ES_PRESET: (id: string, filterId: string) =>
      `${config.baseApiUrl}investor-settings/${id}/es-filters/${filterId}`,
    COPY_ES_PRESET: (id: string, filterId: string) =>
      `${config.baseApiUrl}investor-settings/${id}/es-filters/${filterId}/copy`,
    DELETE_PRESET: (id: string, filterId: string) => `${config.baseApiUrl}investor-settings/${id}/filters/${filterId}`,
    DELETE_ES_PRESET: (id: string, filterId: string) =>
      `${config.baseApiUrl}investor-settings/${id}/es-filters/${filterId}`,
    GET_FILTER_FIELDS: `${config.baseApiUrl}investor-settings/filter-fields`,
    PROCESS_INVESTOR_FILE: (id: string) => `${config.baseApiUrl}investor-settings/${id}/processings`,
  },
  ACCOUNT: {
    CREATE_ACCOUNT: `${config.baseApiUrl}accounts`,
    UPDATE_CURRENT: `${config.baseApiUrl}accounts`,
    UPDATE_ACCOUNT: (id: number) => `${config.baseApiUrl}accounts/${id}`,
    DELETE_ACCOUNT: (id: number) => `${config.baseApiUrl}accounts/${id}`,
    UPDATE_PRIMARY_USER: (id: number) => `${config.baseApiUrl}accounts/${id}/user`,
    GET_CSM_MANAGER: (id: number) => `${config.baseApiUrl}accounts/${id}/csm-manager`,
    GET_CHECKOUT_URL: `${config.baseApiUrl}accounts/checkout-url`,
    CHECK_PAYMENT_METHOD_EXISTENCE: `${config.baseApiUrl}accounts/payment-method`,
    GET_BILLING_PORTAL_URL: `${config.baseApiUrl}accounts/billing-portal-url`,
    GET_INVOICES: `${config.baseApiUrl}accounts/invoices`,
    PAY_INVOICE: (invoiceId: number) => `${config.baseApiUrl}accounts/invoices/${invoiceId}/payment`,
    GET_ACCOUNTS_LIST: `${config.baseApiUrl}accounts`,
    // todo do not remove id, being used for fetching clients
    GET_ACCOUNT: (id: number) => `${config.baseApiUrl}accounts/${id}`,
    SYNC_ACCOUNT: (id: number) => `${config.baseApiUrl}accounts/${id}/sync`,
    GET_ACCOUNT_USERS: () => `${config.baseApiUrl}accounts/users`,
    GET_ACCOUNT_PROPERTY_LISTS: `${config.baseApiUrl}accounts/property-lists`,
    CREATE_ACCOUNT_PROPERTY_LIST: `${config.baseApiUrl}accounts/property-lists`,
    GET_ACCOUNT_NOTES: `${config.baseApiUrl}accounts/notes`,
    CREATE_ACCOUNT_NOTE: `${config.baseApiUrl}accounts/notes`,
    GET_ACCOUNT_ATTEMPTS: `${config.baseApiUrl}accounts/attempts`,
    SAVE_ACCOUNT_ATTEMPTS: `${config.baseApiUrl}accounts/attempts`,
    LIST_ACCOUNT_PROPERTY_LIST_TO_PROPERTIES_FROM_FILE: `${config.baseApiUrl}accounts/property-lists/link-to-properties-from-file`,
    LIST_ACCOUNT_PROPERTY_LIST_TO_PROPERTY: `${config.baseApiUrl}accounts/property-lists/link-to-property`,
    GET_FEATURES: `${config.baseApiUrl}accounts/features`,
    DOWNLOAD_CSV_PROPERTY_RECORDS: `${config.baseApiUrl}accounts/download-property-records`,
    CHECK_ACCOUNT: `${config.baseApiUrl}accounts/check`,
    SET_ACTIVE_ACCOUNT: `${config.baseApiUrl}accounts/active`,
    ACTIVATE: `${config.baseApiUrl}accounts/activate`,
    DEACTIVATE: `${config.baseApiUrl}accounts/deactivate`,
    GET_SUBSCRIPTION: (id: number) => `${config.baseApiUrl}accounts/subscription/${id}`,
    GET_SUBSCRIPTIONS: `${config.baseApiUrl}accounts/subscriptions`,
    UPDATE_SUBSCRIPTION: (id: number) => `${config.baseApiUrl}accounts/subscription/${id}`,
    ACCOUNT_PAYMENT: `${config.baseApiUrl}accounts/payment`,
    GET_ACCOUNT_INVOICE: (invoiceId: number) => `${config.baseApiUrl}accounts/invoices/${invoiceId}`,
    ACCOUNT_PAYMENT_METHODS: `${config.baseApiUrl}accounts/payment-methods`,
    MOVE_USER_TO_ANOTHER_COMPANY: `${config.baseApiUrl}accounts/move-user-to-another-company`,
    ADJUST_BALANCE: (accountId: number) => `${config.baseApiUrl}accounts/${accountId}/balance/adjust`,
  },
  FEATURES: {
    GET_LIST: `${config.baseApiUrl}features`,
    OVERRIDE: `${config.baseApiUrl}features`,
    RESET: `${config.baseApiUrl}features`,
  },
  HUBSPOT_HISTORY: {
    GET_HUBSPOT_HISTORY_LIST: `${config.baseApiUrl}hubspot-properties-history`,
    UPDATE_HUBSPOT_HISTORY_ITEM_STATUS: (id: string) => `${config.baseApiUrl}hubspot-properties-history/${id}`,
  },
  STATE: {
    GET_STATES_LIST: `${config.baseApiUrl}states`,
  },
  COUNTY: {
    GET_COUNTIES_LIST: `${config.baseApiUrl}counties`,
    GET_COUNTY_ZIPS: `${config.baseApiUrl}counties/zips`,
    GET_COUNTY_NEIGHBORHOOD_LIST: (id: number) => `${config.baseApiUrl}counties/${id}/neighborhoods`,
  },
  CLARITAS: {
    GET_VISITORS: (id: string) => `${config.baseApiUrl}claritas/${id}/visitors`,
    GET_STATISTICS: (id: string) => `${config.baseApiUrl}claritas/${id}/statistics`,
    GET_VISITORS_FILE: (id: string) => `${config.baseApiUrl}claritas/${id}/visitors/file`,
  },
  PAY_PER_LEAD: {
    GET_LEADS: `${config.baseApiUrl}leads`,
    GET_LEADS_COUNTIES: `${config.baseApiUrl}leads/counties`,
    DISPUTE_LEAD: `${config.baseApiUrl}leads/disputes`,
    GET_LEAD_BY_ID: (id: string) => `${config.baseApiUrl}leads/${id}`,
    GET_LEAD_PRICE: `${config.baseApiUrl}leads/price`,
    BATCH_QUALIFY_LEADS: `${config.baseApiUrl}leads/batch/qualify`,
    BATCH_EXPORT_LEADS: `${config.baseApiUrl}leads/batch/export`,
    GET_SUBSCRIPTIONS_LIST: `${config.baseApiUrl}leads/subscriptions-list`,
    GET_SUBSCRIPTIONS: `${config.baseApiUrl}leads/subscriptions`,
    GET_SUBSCRIPTION: (id: number) => `${config.baseApiUrl}leads/subscriptions/${id}`,
    CREATE_SUBSCRIPTION: `${config.baseApiUrl}leads/subscriptions`,
    UPDATE_SUBSCRIPTION: `${config.baseApiUrl}leads/subscriptions`,
    UPDATE_SUBSCRIPTION_BILLING: `${config.baseApiUrl}leads/subscriptions/billing`,
    PURCHASE_SUBSCRIPTION: (id: number) => `${config.baseApiUrl}leads/subscriptions/${id}/purchase`,
    SET_DISCOUNT: (id: number) => `${config.baseApiUrl}leads/subscriptions/${id}/discount`,
    GET_QUOTE: (id: number) => `${config.baseApiUrl}leads/subscriptions/${id}/quote`,
    // admin section
    GET_ADMIN_CUSTOMERS: `${config.baseApiUrl}leads/customers`,
    GET_ADMIN_DISPUTES: `${config.baseApiUrl}leads/disputes`,
    UPDATE_ADMIN_DISPUTES: (disputeId: number) => `${config.baseApiUrl}leads/disputes/${disputeId}`,
    UPDATE_LEAD_QUALITY: `${config.baseApiUrl}leads/batch/qualify`,
    GET_STATISTICS: `${config.baseApiUrl}leads/statistics`,
    GET_FILTER_OPTIONS: `${config.baseApiUrl}leads/filter-options`,
    GET_SUBSCRIPTION_STATISTICS: `${config.baseApiUrl}leads/statistics/subscriptions`,
    APPLY_NEW_PRICES: `${config.baseApiUrl}leads/counties`,
    PAUSE_SUBSCRIPTION: (id: number) => `${config.baseApiUrl}leads/subscriptions/${id}/pause`,
    GET_BUYER_PROFILE: (accountId: number) => `${config.baseApiUrl}ppl-buyer-profiles/${accountId}`,
    CREATE_BUYER_PROFILE: (accountId: number) => `${config.baseApiUrl}ppl-buyer-profiles/${accountId}`,
    UPDATE_BUYER_PROFILE: (accountId: number) => `${config.baseApiUrl}ppl-buyer-profiles/${accountId}`,
  },
  PROPERTIES: {
    GET_PROPERTIES: `${config.baseApiUrl}properties`,
    GET_PROPERTIES_CSV: `${config.baseApiUrl}properties/csv`,
    GET_PROPERTY_TYPES: `${config.baseApiUrl}properties/types`,
    GET_PROPERTY: (id: number) => `${config.baseApiUrl}properties/${id}`,
    CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD: (id: number) =>
      `${config.baseApiUrl}properties/check-for-assign/${id}`,
    ASSIGNED_TO_LEAD: `${config.baseApiUrl}properties/assign-to-lead`,
  },
  MARKET_MAP: {
    GET_ZIP_CODES: (accountId: number, fip: string, zipsOnly: boolean) => {
      if (zipsOnly) {
        return `${config.baseApiUrl}accounts/${accountId}/counties/${fip}/zips`;
      } else {
        const query = new URLSearchParams({ zipsOnly: "false" });
        return `${config.baseApiUrl}accounts/${accountId}/counties/${fip}/zips?${query}`;
      }
    },
    GET_CITIES: () => {
      return `${config.baseApiUrl}counties/cities`;
    },
    GET_NEIGHBORHOODS: () => {
      return `${config.baseApiUrl}counties/neighborhoods`;
    },
    GET_COUNTY_GEO_DATA: (code: string) => `${config.baseApiUrl}counties/geo/${code}`,
    GET_COUNTY_NEIGHBORHOODS_GEO_DATA: (code: string) => `${config.baseApiUrl}counties/${code}/geo/neighborhoods`,
    GET_COUNTY_NEIGHBORHOOD_METRICS_BY_ES_ID: (esId: string) =>
      `${config.baseApiUrl}counties/metrics/neighborhood/${esId}`,
    GET_ZIP_METRICS: (fips: string, zipCode: string) =>
      `${config.baseApiUrl}accounts/counties/${fips}/zips/${zipCode}/metrics`,

    GET_COUNTY_METRICS: (fips: string) => `${config.baseApiUrl}accounts/counties/${fips}/metrics`,

    GET_ZIPS_TABLE: ({ from, size, state, fips, zip }: GetZipsQuery) => {
      const filters: { fips?: string; zip?: string } = {};

      if (fips) filters.fips = fips;
      if (zip) filters.zip = zip;

      const query = new URLSearchParams({
        from: from.toString(),
        size: size.toString(),
        state,
        ...filters,
      });

      return `${config.baseApiUrl}accounts/zips-paginated?${query}`;
    },
    GET_NEIGHBORHOODS_TABLE: `${config.baseApiUrl}accounts/neighborhoods-paginated`,
    GET_FILTERED_BUY_BOX_DATA: ({ fips, accountID, ...filters }: GetBuyBoxDataQuery) => {
      const query = new URLSearchParams({ fips });

      for (const [key, value] of Object.entries(filters)) {
        value.forEach((value) => {
          query.append(key, value.toString());
        });
      }

      if (accountID) {
        query.append("account", accountID.toString());
      }

      return `${config.baseApiUrl}buy-box/${fips}/?${query}`;
    },

    GET_PRESET_BUY_BOX_DATA: (filters: BuyBoxPresetDto) => {
      const query = new URLSearchParams();

      for (const [key, value] of Object.entries(filters)) {
        if (key === "distressors_buckets") {
          value?.forEach((v: string) => query.append(key, v));

          if (value?.length === 1) {
            query.append(key, "");
          }
        } else if (Array.isArray(value)) {
          value.length && query.append(key, value.join(","));
        } else {
          if (typeof value === "boolean") {
            query.append(key, value.toString());
          } else {
            value && query.append(key, value);
          }
        }
      }
      return `${config.baseApiUrl}buy-box/presets?${query}`;
    },
    EXPORT_ZIPS_TO_CSV: ({ state, fips, zip }: ZipsToCSVQueryParams) => {
      const queryParams: ZipsToCSVQueryParams = {
        state: state.toString(),
      };

      if (fips) queryParams.fips = fips.toString();
      if (zip) queryParams.zip = zip.toString();

      const query = new URLSearchParams(queryParams as unknown as Record<string, string>);

      return `${config.baseApiUrl}accounts/zips-table-csv?${query}`;
    },
    EXPORT_NEIGHBORHOODS_ZIPS_TO_CSV: `${config.baseApiUrl}accounts/neighborhoods-table-csv`,
  },
  TICKETS: {
    GET_TICKET_LIST: `${config.baseApiUrl}tickets`,
    UPDATE_TICKET: (id: number) => `${config.baseApiUrl}tickets/${id}`,
  },
  NICHE_FILES: {
    GET_FILE_PRICE: `${config.baseApiUrl}niche-files/price`,
    SUBSCRIPTIONS: `${config.baseApiUrl}niche-files/subscriptions`,
    SUBSCRIPTION: (id: string) => `${config.baseApiUrl}niche-files/subscriptions/${id}`,
    CANCEL_SUBSCRIPTION: (id: string) => `${config.baseApiUrl}niche-files/subscriptions/${id}/cancel`,
    RENEW_SUBSCRIPTION: (id: string) => `${config.baseApiUrl}niche-files/subscriptions/${id}/renew`,
    CREATE_CHECKOUT_LINK: (id: string) => `${config.baseApiUrl}niche-files/subscriptions/${id}checkout`,
    GET_FILES: `${config.baseApiUrl}niche-files`,
    GET_FILE: (id: number) => `${config.baseApiUrl}niche-files/${id}`,
    GET_FILE_SIGNED_URL: (id: number) => `${config.baseApiUrl}niche-files/${id}/signed-url`,
    DELETE_FILE: (id: number) => `${config.baseApiUrl}niche-files/${id}`,
    UPDATE_FILE_STATUS: (id: number) => `${config.baseApiUrl}niche-files/${id}/status`,
  },
  OAUTH: {
    AUTHORIZE: `${config.baseApiUrl}oauth/authorize`,
  },
};
